import type NewRelicBrowser from 'new-relic-browser';
import { API_ROOT } from '../config';
import {
  getAndroidVersion,
  getAppVersion,
  getIOSVersion,
  getIsApp,
  getOS,
} from './AppInfo';
import { isPreStage } from './env';

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    newrelic: typeof NewRelicBrowser;
  }
}
/**
 * Send error to newrelic, optionally adding data.
 *
 * Also logs the error to the console if not in prod.
 *
 * @param   {unknown} error
 * @param   {Object} data  Optional data passed Page Action
 * @returns {undefined}
 */
export default function nonCriticalException(
  error: unknown,
  data: Record<string, any> | undefined = undefined,
) {
  if (typeof window === 'object' && 'newrelic' in window) {
    const attributes = {
      environmentName: process.env.ENV_NAME || 'local',
      apiRoot: API_ROOT,
      appVersion: getAppVersion(),
      isApp: getIsApp(),
      osType: getOS(),
      iosVersion: getIOSVersion(),
      androidVersion: getAndroidVersion(),
    };
    window.newrelic.noticeError(
      error instanceof Error ? error : String(error),
      attributes,
    );

    if (typeof data !== 'undefined') {
      const message = error instanceof Error ? error.message : String(error);
      window.newrelic.addPageAction(message, data);
    }
  }

  if (isPreStage()) {
    // eslint-disable-next-line no-console
    console.error(error, data);
  }
}
